export { WoundDashContainer as default } from "./WoundDashContainer";
